import { Button } from 'semantic-ui-react';
import moment from 'moment';
import churchForms from 'src/services/api/churchForms';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { deleteForm } from 'src/components/helpers';

export const getComunidadNetworkColumnDefs = ({ onView, onDeleted }) => [
  {
    headerName: 'Cédula',
    field: 'Guest.identification',
    width: 140,
    cellRenderer: (params) => params.data?.Guest?.identification || '',
  },
  {
    headerName: 'Nombre',
    field: 'Guest.name',
    width: 200,
    cellRenderer: (params) => {
      const guest = params.data?.Guest;
      if (!guest) return '';
      return `${guest.name || ''} ${guest.lastName || ''}`.trim();
    },
  },
  {
    headerName: 'Celular',
    field: 'Guest.phone',
    width: 140,
    cellRenderer: (params) => params.data?.Guest?.phone || '',
  },
  {
    headerName: 'Empresa',
    field: 'businessName',
    width: 200,
    cellRenderer: (params) => params.data?.businessName || '',
  },
  {
    headerName: 'Categoría',
    field: 'category',
    width: 180,
    cellRenderer: (params) => params.data?.category || '',
  },
  {
    headerName: 'Producto',
    field: 'serviceOffered',
    width: 260,
    cellRenderer: (params) => {
      const serviceOffered = params.data?.serviceOffered || '';
      if (!serviceOffered) return '';
      return `${serviceOffered.substring(0, 100)}${serviceOffered.length > 99 ? ' (...)' : ''}`;
    },
  },
  {
    headerName: 'Fecha creación',
    field: 'createdAt',
    width: 140,
    cellRenderer: (params) => {
      if (!params.data?.createdAt) return '';
      return moment.tz(params.data.createdAt, 'America/Bogota').format('DD-MM-YYYY');
    },
  },
  {
    headerName: 'Publicado',
    field: 'published',
    width: 120,
    cellRenderer: (params) => {
      if (!params.data) return '';
      return params.data.published ? 'Sí' : 'No';
    },
  },
  {
    headerName: 'Cambios',
    field: 'pendingRevision',
    width: 130,
    cellRenderer: (params) => (params.data?.pendingRevision ? 'Por revisar' : ''),
  },
  {
    headerName: 'Ver',
    field: 'id',
    width: 110,
    sortable: false,
    filter: false,
    cellRenderer: (params) => {
      const { data } = params;
      if (!data) return '';
      return (
        <Button primary className="btn-grid" onClick={() => onView(data)}>
          Ver
        </Button>
      );
    },
  },
  {
    headerName: 'Eliminar',
    field: 'delete',
    width: 130,
    sortable: false,
    filter: false,
    cellRenderer: (params) => {
      const { data } = params;
      if (!data) return '';
      return (
        <Button
          className="btn-grid"
          onClick={() =>
            deleteForm({
              subtitle: data.businessName,
              Swal,
              func: ({ text, successAlert }) => {
                churchForms
                  .postComunidadNetwork({ deleted: text, id: data.id }, true)
                  .then((response) => {
                    if (response.data.success) {
                      successAlert();
                      onDeleted?.();
                    }
                  })
                  .catch((error) => {
                    if (error.response) Swal.fire(error.response.data.message);
                  });
              },
            })
          }
        >
          Eliminar
        </Button>
      );
    },
  },
];

const ComunidadNetworkRow = (props) => {
  const { network, set_showComunidadNetwork, getInfo } = props;

  const { id, businessName, serviceOffered, published, createdAt, Guest } = network;
  const { identification, name, phone, lastName } = Guest;

  return (
    <tr>
      <td>
        <p style={{ margin: '0' }}>{identification}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>
          {name} {lastName}
        </p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{phone}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{businessName}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>
          {serviceOffered.substring(0, 100)}
          {serviceOffered.length > 99 && ' (...)'}
        </p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{moment.tz(createdAt, 'America/Bogota').format('DD-MM-YYYY')}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{published ? 'Sí' : 'No'}</p>
      </td>
      <td>
        <Button primary onClick={() => set_showComunidadNetwork(id)}>
          Ver
        </Button>
      </td>
      <td>
        <Button
          onClick={() =>
            deleteForm({
              subtitle: businessName,
              Swal,
              func: ({ text, successAlert }) => {
                churchForms
                  .postComunidadNetwork({ deleted: text, id }, true)
                  .then((response) => {
                    if (response.data.success) {
                      successAlert();
                      getInfo();
                    }
                  })
                  .catch((error) => {
                    if (error.response) Swal.fire(error.response.data.message);
                  });
              },
            })
          }
        >
          Eliminar
        </Button>
      </td>
    </tr>
  );
};

export default ComunidadNetworkRow;
